import React, { Component } from 'react';
import { Redirect, Route, Switch, BrowserRouter} from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import Loadable from 'react-loadable';
import './App.scss';
import { getAccessToken } from './auth';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading
});

// Pages
const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading
});

const ProtectedLayout = props => getAccessToken()
  ? <DefaultLayout {...props} />
  : <Redirect to="/" />;

class App extends Component {

  render() {
    return (
      <BrowserRouter>
          <Switch>
            <Route exact path="/" name="Login Page" component={Login} />
            <Route path="/" name="Home" component={ProtectedLayout} />
          </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
